import { InternalDashboardHeader } from './Header';
import { InternalDashboardContent } from './Content';
import { DashboardMetrics } from '../../pages/dashboardPage/DashboardMetrics';
import { ModalEditConfig } from './ModalEditConfig';
// ModalValidateInvoice has been removed
import { ModalResolve } from './ModalResolve';
import { ModalResolutionMessage } from './ModalResolutionMessage';
import { ModalUserMessage } from './ModalUserMessage';
import { ModalErrorMessage } from './ModalErrorMessage';
import { useInternalDashboardMetrics } from '../../../../use-cases/metric/useMetric';
import { internalDashboardMetricMapper } from '../../pages/dashboardPage/dashboardMetricsMapper';
import { ModalEditOcrData } from './ModalEditOcrData.tsx';
import { ModalEditInvoice } from './ModalEditInvoiceData .tsx';
import { ModalValidateInvoice } from './validateInvoice/ModalValidateInvoice.tsx';
import { useInternalDashboardSelector } from './Selector.tsx';
import { ModalReprocessShipment } from './ModalReprocessShipment.tsx';

export const InternalDashboardMain = () => {
  const { data: metricsData, isLoading: isLoadingMetrics } = useInternalDashboardMetrics();
  const metricItems = internalDashboardMetricMapper(metricsData);
  const {
    isShowEditConfig,
    isShowEditInvoiceData,
    isValidateInvoice,
    isShowEditOcrData,
    isShowResolve,
    isShowResolutionMessage,
    isShowErrorMessage,
    isShowUserMessage,
    isShowReprocessShipment,
  } = useInternalDashboardSelector();

  return (
    <>
      <InternalDashboardHeader items={metricsData} isLoading={isLoadingMetrics} />
      <DashboardMetrics items={metricItems} isLoading={isLoadingMetrics} />
      <InternalDashboardContent />

      {isShowEditConfig && <ModalEditConfig />}
      {isShowEditInvoiceData && <ModalEditInvoice />}
      {isValidateInvoice && <ModalValidateInvoice />}
      {isShowEditOcrData && <ModalEditOcrData />}
      {isShowResolve && <ModalResolve />}
      {isShowResolutionMessage && <ModalResolutionMessage />}
      {isShowErrorMessage && <ModalErrorMessage />}
      {isShowUserMessage && <ModalUserMessage />}
      {isShowReprocessShipment && <ModalReprocessShipment />}
    </>
  );
};
